import React from 'react'
import { useSelector } from 'react-redux';

const Loader = () => {
    const loading = useSelector((state) => state.loader.loading);

    if (!loading) return null;
    
  return (
    <div className="loader-overlay">
      <div className="loader"></div>
    </div>
  )
}

export default Loader
